import client from './client';

export interface Store {
  id: number;
  business_name: string;
  vertical?: 'grocery' | 'food';
  description?: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  postal_code: string;
  latitude: number;
  longitude: number;
  is_open: boolean;
  is_active: boolean;
  rating: number;
  total_orders: number;
  opening_hours: string;
  closing_hours: string;
  service_radius_km?: number;
}

export interface NearbyStore {
  id: number;
  business_name: string;
  distance_km: number;
  rating: number;
  is_open: boolean;
  delivery_fee: number;
}

export const storesAPI = {
  async createStore(data: any): Promise<Store> {
    const response = await client.post<Store>('/api/stores', data);
    return response.data;
  },

  async getStore(storeId: number): Promise<Store> {
    const response = await client.get<Store>(`/api/stores/${storeId}`);
    return response.data;
  },

  async getMyStore(): Promise<Store> {
    const response = await client.get<Store>('/api/stores/me/store');
    return response.data;
  },

  async updateStore(storeId: number, data: any): Promise<Store> {
    const response = await client.put<Store>(`/api/stores/${storeId}`, data);
    return response.data;
  },

  async toggleStoreStatus(storeId: number, isOpen: boolean): Promise<any> {
    const response = await client.patch(`/api/stores/${storeId}/status?is_open=${isOpen}`);
    return response.data;
  },

  async listStores(skip: number = 0, limit: number = 100): Promise<Store[]> {
    const response = await client.get<Store[]>('/api/stores', {
      params: { skip, limit }
    });
    return response.data;
  },

  async findNearbyStores(
    latitude: number,
    longitude: number,
    radiusKm: number = 10,
    skip: number = 0,
    limit: number = 100
  ): Promise<NearbyStore[]> {
    const response = await client.post<NearbyStore[]>('/api/stores/nearby', {
      latitude,
      longitude,
      radius_km: radiusKm,
    }, {
      params: { skip, limit }
    });
    return response.data;
  },

  async getStoreStats(storeId: number): Promise<any> {
    const response = await client.get(`/api/stores/${storeId}/stats`);
    return response.data;
  },
};
